import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
// import useCustomStyles from '../../../hooks/useCustomStyles';
// import { RootState } from '../../../store/store';
import { header2Styles } from '../../../assets/styles/header2'
import { shareQrCode } from '../../../assets/styles/ClientsStyles/shareQrCode'
import { RootState } from '../../../store/store'
import useCustomStyles from '../../../hooks/useCustomStyles'
import { ReactComponent as Download } from '../../../assets/images/Download.svg'

import CustomDisplay from '../../../components/CustomDisplay'
import QRCode from 'react-qr-code'
import { PendingClientType } from '../../../store/slices/clientsSlice'

interface ShareAccessCodeClientModalProps {
  isOpen: boolean
  client: PendingClientType | null
  onConfirm: () => void
  onCancel: () => void
}

const ShareAccessCodeClientModal: React.FC<ShareAccessCodeClientModalProps> = ({
  isOpen,
  client,
  onCancel,
}) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const { theme } = useSelector((state: RootState) => state.theme_slice)
  const classes = useCustomStyles(header2Styles, theme)
  const classes1 = useCustomStyles(shareQrCode, theme)

  const qrWrapperRef = useRef<HTMLDivElement | null>(null)
  ////NOTE: I'M USING STATIC QR CODE BASSAM
  const downloadQRCode = () => {
    if (qrWrapperRef.current) {
      // Find the SVG element inside the wrapper
      const svg = qrWrapperRef.current.querySelector('svg')
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg)
        const svgBlob = new Blob([svgData], {
          type: 'image/svg+xml;charset=utf-8',
        })
        const url = URL.createObjectURL(svgBlob)

        // Create a download link
        const link = document.createElement('a')
        link.href = url
        link.download = `QR_Code_${client?.access_code_data[0].id}.svg`
        document.body.appendChild(link)
        link.click()

        // Cleanup
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    }
  }
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onCancel()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [isOpen, onCancel])

  if (!isOpen) return null

  return (
    <div className={classes.overlay}>
      <div className={classes.modal} ref={modalRef}>
        <h2 className={classes.headerTextLogOutModal}>Share access code</h2>
        <div className={classes1.qrWrapper}>
          <div ref={qrWrapperRef} className={classes1.qrContainer}>
            <QRCode value={client?.access_code_data[0].id || ''} size={180} />
          </div>

          <div className={classes1.actionButton} onClick={downloadQRCode}>
            <div className={classes1.buttonIcon}>
              <Download width={20} height={20} />
            </div>
            <p className={classes1.buttonText}>Download </p>
          </div>
        </div>
        <CustomDisplay
          // label={"Access Code"}
          value={client?.access_code_data[0].id || ''}
          allowCopy
        />
      </div>
    </div>
  )
}

export default ShareAccessCodeClientModal
